<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Create subject
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <Form
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              @closed="closeModal"
              />

            <v-divider/>
        
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Subject List"
          text="All subject of all courses"
        >

          <v-data-table
            :headers="headers"
            :items="subjectList"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> {{ item.name }}</td>
              <td>{{ item.color_name }}</td>
            </template>
          </v-data-table>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from '@/views/Form'
export default {
  components: {
    Form
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('subjects', ['subjectList']),
  },
  mounted () {
    this.GetSubjectList()
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      
    headers: [
      {
        sortable: true,
        text: 'Subject',
        value: 'name'
      },
      {
        sortable: false,
        text: 'Color',
        value: 'color_name'
      },
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Create new',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: { },
      inputFields: [
        {
          label: 'Subject Name',
          type: 'text',
          isEnable: true,
          name: 'name',
          formName: 'Subject name',
          nameRules: [
            v => !!v || 'Subject name is required',
            v => (v && v.length <= 30) || 'First name must be less than 30 characters'
          ]
        },
        {
          label: 'Subject Name (বাংলা)',
          type: 'text',
          isEnable: true,
          name: 'name_bn',
          formName: 'Subject name (বাংলা)',
          nameRules: [
            v => !!v || 'Subject name is required',
            v => (v && v.length <= 30) || 'First name must be less than 30 characters'
          ]
        },
        {
          label: 'Color name',
          type: 'text',
          isEnable: true,
          name: 'color_name',
          formName: 'color_name',
           nameRules: [
            v => !!v || 'Color name is required',
            v => (v && v.length <= 30) || 'First name must be less than 30 characters',
          ]
        }
       
      ]
    }
  },
  created () {
  },
  methods: {
    ...mapActions("subjects", ["fetchData","CreateSubject", "GetSubjectList"]),

    getBackData (data) {
      this.CreateSubject(data).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
          this.GetSubjectList()
          this.dialog = false
            this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    closeModal () {
      this.dialog = false
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      // this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
